import { EditorState, convertToRaw, convertFromRaw } from "draft-js";

// Универсальное сохранение
export const saveToLocal = (key: string, value: any) => {
  try {
    // console.log("saveToLocal called with key:", key, "value:", value);
    const dataToSave =
      value instanceof EditorState
        ? { __editorState: true, content: convertToRaw(value.getCurrentContent()) }
        : value;

    const serialized = JSON.stringify(dataToSave);
    // console.log("saveToLocal - serialized data:", serialized);
    localStorage.setItem(key, serialized);
    // console.log("saveToLocal - data saved successfully");
  } catch (err) {
    console.error("Ошибка сохранения в localStorage", err);
  }
};

// Универсальная загрузка
export const loadFromLocal = <T = unknown>(key: string): T | EditorState | null => {
  try {
    // console.log("loadFromLocal called with key:", key);
    const serialized = localStorage.getItem(key);
    // console.log("loadFromLocal - serialized from localStorage:", serialized);
    if (serialized === null) {
      // console.log("loadFromLocal - no data found in localStorage");
      return null;
    }

    const parsed = JSON.parse(serialized);
    // console.log("loadFromLocal - parsed data:", parsed);

    if (parsed?.__editorState && parsed?.content?.blocks) {
      return EditorState.createWithContent(convertFromRaw(parsed.content));
    }

    return parsed as T;
  } catch (err) {
    console.error("Ошибка чтения из localStorage", err);
    return null;
  }
};


export const removeFromLocal = (key: string) => {
  localStorage.removeItem(key);
};
